import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { SITE_WHATSAPP } from "./branding";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Prefer logo when the same brand slug appears across categories. */
export function dedupeBrandsBySlug(brands) {
  const seen = new Map();
  for (const brand of brands || []) {
    const key = (brand.slug || brand.name || '').toLowerCase();
    if (!key) continue;
    const existing = seen.get(key);
    if (!existing || (!existing.logo && brand.logo)) {
      seen.set(key, brand);
    }
  }
  return Array.from(seen.values());
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function truncate(str, length = 100) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function generateWhatsAppLink(message) {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${SITE_WHATSAPP}?text=${encodedMessage}`;
}

export function getProductWhatsAppMessage(product, category, brand) {
  return `Hi, I'm interested in ${product?.name || 'your products'}${category ? ` from ${category}` : ''}${brand ? ` by ${brand}` : ''}. Please share more details.`;
}

export function getCategoryWhatsAppMessage(category) {
  return `Hi, I'm interested in your ${category} collection. Please share the catalog and pricing.`;
}

export function getGeneralWhatsAppMessage() {
  return `Hi, I'm interested in becoming a wholesale partner with Silver Perfumes. Please share more details about your products and terms.`;
}
